import { useQuery } from 'react-query';
import RdBudgetFormService from '../../../services/rdBudgetFormService';

export const useReportHistoryQuery = (
  organizationId: string,
  propertyId: string,
  rentForecastId: string,
  callback: () => void,
) => {
  return useQuery(
    ['useReportHistoryRequest', organizationId, propertyId, rentForecastId],
    () =>
      new RdBudgetFormService().getAllReports(
        organizationId,
        propertyId,
        rentForecastId,
      ),
    {
      enabled: Boolean(propertyId && organizationId && rentForecastId),
      refetchOnWindowFocus: false,
      initialData: [],
      onSuccess: callback,
    },
  );
};
